/* global s */
'use strict';

class VoiceCredit {
	constructor(options) {
		this.defaults = {
			sell_countries: [],
			voice_credit_id: '',
			selected_value: '',
			selected_country: '',
			cached_rates: {},
			featured: false,
			tracking_params: {
				destination: 'Other',
				product_type: '',
				product_details: ''
			},
			all_rates_trigger: 'see-all-rates-trigger',
			credit_sell_countries_id: 'credit-sell-countries',
			custom_amount_id: 'buy-custom-amount',
			custom_amount_container_id: 'custom-amount-container',
			predefined_amounts_class: '.predefined-rate',
			product_selector_id: 'product-selector-credit',
			rate_placeholders_selectors: {
				top_text: '.rate-top',
				middle_text: '.rate-middle',
				bottom_text: '.rate-bottom',
				rates_container: 'country_rates'
			},
			mpa_texts: {
				sms_for_amount: 'SMS_FOR_AMOUNT',
				minutes_for_amount: 'MINUTES_FOR_AMOUNT',
				unlimited_messages: 'UNLIMITED_MESSAGES',
				unlimited_minutes: 'UNLIMITED_MINUTES',
				please_enter_an_amount: 'PLEASE_ENTER_AN_AMOUNT'
			},
			buy_form_selectors: {
				voice_quantity: 'voice_quantity',
				voice_product_id: 'voice_product_id',
				form_buy_voice: 'form_buy_voice',
				buy_button_id: 'buy-button'
			}
		};
		this.options = Object.assign(this.defaults, options);
		this._rates_container = document.getElementById(this.options.rate_placeholders_selectors.rates_container);
		console.log('VoiceCredit::constructor(%o)', this.options);
		this.pageEvents();
	}

	/**
	 * Gets the country rates from process_rates.php for a specific country
	 *
	 * @param {string}    country          Country name
	 * @param {boolean}   external         If called from the tariff_plan section. Don't focus in this case
	 * @param {boolean}   custom_amount    If called from the custom amount field
	 *
	 * @return {type} Description.
	 */

	getCountryRates(country, external, custom_amount = false) {
		console.log('getCountryRates(%o, %o, %o)', country, external, custom_amount);
		const _this = this;
		if (country && country.length > 0) {
			const _last_country = country;
			country = country.toUpperCase();
			this.options.selected_country = country;
			if (!external && typeof s.tariff_plan !== 'undefined') {
				s.tariff_plan.resetPlans();
			}
			if (_this._rates_container) {
				if (external) {
					_this._rates_container.classList.remove('active');
				} else {
					_this._rates_container.classList.add('active');
				}
				if (_this.options.cached_rates[country]) {
					_this.displayCountryRates(_this.options.cached_rates[country]);
				} else {
					_this._rates_container.innerHTML = '';
					if (s.options.page_ajax.rates_for_country) {
						s.options.page_ajax.rates_for_country.abort();
					}
					s.options.page_ajax.rates_for_country = $.ajax({
						url: s.url('process_rates'),
						type: 'post',
						dataType: 'json',
						data: {
							action: 'country_destinations',
							destination: country
						},
						success: function (response) {
							_this.displayCountryRates(response);
							_this.options.cached_rates[country] = response;
							_this.options.tracking_params.destination = _last_country;
						}
					});
				}
			}
		}
	}

	/**
	 * Called by getCountryRates.
	 * For each destination will call minutesAmount to get the rate/min details
	 * For each destination will call fillRatePlaceholder with corresponding details
	 *
	 * @param {Object} country_obj     Rates for a specific country
	 *
	 */

	displayCountryRates(country_obj) {
		if (country_obj) {
			const _this = this;
			let _amount_requested;
			$(`#${_this.options.rate_placeholders_selectors.rates_container}`).html('');
			country_obj.forEach( (country) => {
				_amount_requested = '';
				if (this.options.selected_value) {
					_amount_requested = this.minutesAmount(this.options.selected_value, country.rate, country.type);
				} else if (this.options.selected_value) {
					_amount_requested = this.minutesAmount(this.options.selected_value, country.rate, country.type);
				} else {
					_amount_requested = country.minutes_for_amount;
				}
				this.fillRatePlaceholder(
					country.name,
					s.format_money_str(country.rate, s.options.rate_style_placeholder.rate_format_string, true) +
					(country.name.toLowerCase() === 'sms' ? '' : s.it('PER_MIN')),
					_amount_requested
				);
			});
		}
	}

	/**
	 * Fills the html template from options.rate_style_placeholder.html with the corresponding details
	 *
	 * @param {string}   top           Text to fill the top placeholder for the rate section
	 * @param {string}   middle        Text to fill the middle placeholder for the rate section.
	 * @param {string}   bottom        Text to fill the bottom placeholder for the rate section.
	 *
	 */

	fillRatePlaceholder(top, middle, bottom) {
		let _this = this;
		const _el = $(`#${_this.options.rate_placeholders_selectors.rates_container}`);
		const _country_template = $.parseHTML(s.options.rate_style_placeholder.html);
		let _temp_template = $(_country_template).clone();
		let _placeholder = document.createElement('div');
		_placeholder.innerHTML = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
		_placeholder.classList.add('loading-placeholder');
		if (!(top && middle && bottom)) {
			top = middle = bottom = _placeholder.outerHTML;
		}
		_temp_template
			.find(_this.options.rate_placeholders_selectors.top_text)
			.html(top);
		_temp_template
			.find(_this.options.rate_placeholders_selectors.middle_text)
			.html(middle);
		_temp_template
			.find(_this.options.rate_placeholders_selectors.bottom_text)
			.html(bottom);
		_temp_template.addClass('p-15');
		_el.css({'border-width': '0.1rem'})
			.append(_temp_template);
	}

	/**
	 * Returns the formatted amount/value text to be used in the rate fragment
	 *
	 * @param {float}   amount
	 * @param {float}   rate
	 * @param {string}  type       Destination rate type ( min / sms )
	 *
	 * @return {string} formatted amount/value text
	 */

	minutesAmount(amount, rate, type) {
		let _return_text = '';
		if (rate && type) {
			if (amount) {
				let _minutes, _variable;
				_minutes = Math.floor(amount / (parseFloat(rate) / 100));
				_variable = type === 'sms' ? this.options.mpa_texts.sms_for_amount : this.options.mpa_texts.minutes_for_amount;
				if (_minutes === 666) {
					_minutes = 665;
				}
				if (rate === 0) {
					_variable = type === 'sms' ? this.options.mpa_texts.unlimited_messages : this.options.mpa_texts.unlimited_minutes;
				}
				_return_text = s.it(
					_variable,
					{
						'MINUTES': _minutes,
						'AMOUNT': s.format_money(amount)
					});
			} else {
				_return_text = s.it(this.options.mpa_texts.please_enter_an_amount);
			}
		}

		return _return_text;
	}

	/**
	 * Resets the styling for the _buy_voice_section  section.
	 *
	 */

	resetPredefined() {
		if (this._rates_container) {
			this._rates_container.classList.remove('active');
		}
		this.options.tracking_params.product_type = '';
	}

	/**
	 * Validates the amount
	 *
	 * @param {float}     amount
	 * @param {boolean}   valid            If amount is valid or not
	 * @param {boolean}   custom_amount    If called from the custom amount field
	 *
	 */
	checkAmount(amount, valid = false, custom_amount = false) {
		console.log('VoiceCredit::checkAmount(%o, %o, %o)', amount, valid, custom_amount);
		this.options.selected_value = amount;
		document.getElementById(this.options.buy_form_selectors.voice_quantity).value = this.options.selected_value;

		if (valid) {
			this.getCountryRates(this.options.selected_country, false, custom_amount);
			document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = false;
			document.getElementById(this.options.buy_form_selectors.voice_product_id).value = this.options.voice_credit_id;
			this.options.tracking_params.product_details = this.options.selected_value;
			this.options.tracking_params.product_type = 'voice';
		} else {
			document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = true;
		}
	}

	/**
	 * Handles events on the page ( click/change/etc to call the right functions at the right time )
	 */

	pageEvents() {
		const _this = this;
		const buy_voice_section = document.getElementById('buy_voice_section');
		if (buy_voice_section) {
			buy_voice_section.addEventListener('predefined_amount_click', e => {
				console.log('VoiceCredit::predefined_amount_click %o', e);
				document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = false;
				this.checkAmount(e.detail.amount, e.detail.valid, false);
				if (e.detail.apple_code) {
					document.getElementById(this.options.buy_form_selectors.iap_code).value = e.detail.apple_code;
					document.getElementById(this.options.buy_form_selectors.buy_button_id).innerHTML = s.it('APP_PAY_VIA_APPSTORE', {price: e.detail.apple_amount});
				}
				this.resetPredefined();
				if (_this._rates_container) {
					_this._rates_container.classList.add('active');
				}
			});
			buy_voice_section.addEventListener('custom_amount_input', e => {
				console.log('VoiceCredit::custom_amount_input %o', e);
				this.checkAmount(e.detail.amount, e.detail.valid, true);
				this.resetPredefined();
				if (_this._rates_container) {
					_this._rates_container.classList.add('active');
				}
			});
			buy_voice_section.addEventListener('custom_amount_blur', e => {
				console.log('VoiceCredit::custom_amount_blur %o', e);
				this.resetPredefined();
				this.checkAmount(e.detail.amount, e.detail.valid, true);
			});
		}
		if (typeof this.options.credit_sell_countries_id !== 'undefined') {
			let _credit_sell_countries = document.getElementById(this.options.credit_sell_countries_id);
			if (_credit_sell_countries) {
				_credit_sell_countries.addEventListener('change', () => {
					if (_credit_sell_countries.value) {
						this.getCountryRates(_credit_sell_countries.value);
						if (typeof s.tariff_plan !== 'undefined' && s.tariff_plan.options.plan_sell_countries_id) {
							let _plan_sell_countries = document.getElementById(s.tariff_plan.options.plan_sell_countries_id);
							if (_plan_sell_countries) {
								for (let _i=0;_i<_plan_sell_countries.length;_i++) {
									if (_plan_sell_countries.options[_i].value === _credit_sell_countries.value) {
										_plan_sell_countries.value = _credit_sell_countries.value;
										_plan_sell_countries.classList.remove('has-placeholder');
										s.common.changeFlag(_plan_sell_countries);
										s.tariff_plan.displayCountryPlans(
											_credit_sell_countries.options[_credit_sell_countries.selectedIndex].getAttribute('data-country-code')
										);
									}
								}
							}
						}
					}
				});
			}
		}

		/*if (typeof this.options.selected_country !== 'undefined') {
			this.getCountryRates(this.options.selected_country);
		}*/

		if (typeof this.options.product_selector_id !== 'undefined') {
			let _product_selector = document.getElementById(this.options.product_selector_id);
			if (_product_selector) {
				_product_selector.addEventListener('change', () => {
					document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = true;
				});
			}
		}

		if (typeof this.options.rate_placeholders_selectors.rates_container !== 'undefined') {
			if (_this._rates_container) {
				_this._rates_container.addEventListener('click', () => {
					_this._rates_container.classList.add('active');

					if (typeof s.tariff_plan !== 'undefined') {
						s.tariff_plan.resetPlans();
					}
				});
			}
		}

		if (typeof this.options.all_rates_trigger !== 'undefined') {
			let _see_all_rates_trigger = document.getElementById(this.options.all_rates_trigger);
			if (_see_all_rates_trigger) {
				_see_all_rates_trigger.addEventListener('click', (event) => {
					event.preventDefault();
					$('html, body').animate({
						scrollTop: $('#all-rates-large-table').offset().top
					}, 1000);
				});
			}
		}

		if (this.options.buy_form_selectors.buy_button_id !== 'undefined') {
			let _submit_button = document.getElementById(this.options.buy_form_selectors.buy_button_id);
			if (_submit_button) {
				_submit_button.addEventListener('click', () => {
					if (this.options.tracking_params && this.options.tracking_params.product_type) {
						s.track.dataLayerPush({
							'event': 'gtm_remarketing',
							'destination': this.options.tracking_params.destination,
							'product_type': this.options.tracking_params.product_type,
							'product_details': this.options.tracking_params.product_details,
							'dynx_pagetype': 'conversionintent'
						});
					}
				});
			}
		}

		/*
		* Prevent scroll on input type number
		* */
		$('input[type=number]').on('mousewheel', function(e) {
			e.preventDefault();
		});
	}
}
